import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { Grid, Tooltip, TextField, TextareaAutosize } from "@material-ui/core";
//import {TextareaAutosize} from '@mui/material';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Link } from 'react-router-dom';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import SendEmail from "./SendEmail";

let SelectedData = [];

const MessageCenter = () => {
  const [AccountID, setAccountID] = useState('');
  const [AccName, setAccName] = useState('');
  const [AccType, setAccType] = useState('');
  const [StateID, setStateID] = useState('');
  const [staName, setStaName] = useState('');
  const [StateName, setStateName] = useState('');
  const [StateOptions, setStateOptions] = useState([]);
  const [State, setState] = useState('');
  const [AccountName, setAccountName] = useState();
  const [IndustryID, setIndustryID] = useState('');
  const [Industrycmb, setIndustrycmb] = useState([]);
  const [message, setMessage] = useState('');
  const [ActivityTypeID, setActivityTypeID] = useState('');
  const [City, setCity] = useState('');
  const [CountryID, setCountryID] = useState('');
  const [viewPath, setViewPath] = useState('');
  const [Count, setCount] = useState();
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [SelectedRows, setSelectedRows] = useState([]);
  const [EmailData, setEmailData] = useState([]);
  const [EmailCount, setEmailCount] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const [Activitycmb, setActivitycmb] = useState([]);
  const [Statecmb, setStatecmb] = useState([]);
  const [Countrycmb, setCountrycmb] = useState([]);
  const [AccountOptions, setAccountOptions] = useState([]);
  const [responseType, fetchTypeData] = UseFetchData();
  const [responseIndustry, fetchIndustryData] = UseFetchData();
  const [responseAccount, fetchAccountData] = UseFetchData();
  const [responseState, fetchStateData] = UseFetchData();
  const [responseCountry, fetchCountryData] = UseFetchData();
  const [response, fetchData] = UseFetchData();

  const handleOpenModal = () => {
    setAccountID('');
    // 4/feb change
    var ToEmail = [];
    // debugger;
    if (SelectedRows.length > 0) {
      setOpen(true);
      setEmailCount(SelectedRows.length)
      for (var i = 0; i < SelectedRows.length; i++) {
        ToEmail.push(SelectedRows[i].Email);
      }
      setEmailData(ToEmail);
    }
    else {
      alert('Please Select at Least One Data And AllocateTo')
    }
  }

  const WhatsAppMessage = (number) => {
    var uri = "hi hello how are you";
    var WPMsg = document.getElementById('message').value;
    //var res = encodeURI(message);
    var res = encodeURI(WPMsg);
    // debugger;
    var whatsappNumber = number;
    console.log(res);
    console.log(number);
    //console.log(a);
    var path = "https://wa.me/+91" + number + "?text=" + res;
    console.log(path);
    setViewPath(path);
    window.open(path);
  }

  const Openurl = () => {
    window.open(viewPath);
  }

  const AccountData = () => {
    var bodyFormData = new FormData();
    fetchAccountData("MessageCenter/ComboDataMC", bodyFormData);
  }

  const TypeData = () => {
    var bodyFormData = new FormData();
    fetchTypeData("MessageCenter/ComboDataMC", bodyFormData);
  }
  const IndustryData = () => {
    var bodyFormData = new FormData();
    fetchIndustryData("MessageCenter/ComboDataMC", bodyFormData);
  }

  const StateData = () => {
    var bodyFormData = new FormData();
    fetchStateData("MessageCenter/ComboDataMC", bodyFormData);
  }

  const CountryData = () => {
    var bodyFormData = new FormData();
    fetchCountryData("MessageCenter/ComboDataMC", bodyFormData);
  }

  const PopulateData = () => {
    console.log(message);
    var AccoName = "",
      AGroup = null,
      IndID = null,
      Citys = null,
      StaID = null,
      Coun = null,
      AcName = null;
    // debugger;
    var bodyFormData = new FormData();
    if (AccountName !== undefined) {
      AccoName = AccountName.List;
    }
    if (IndustryID !== "") {
      IndID = IndustryID;
    }
    if (City !== "") {
      Citys = City;
    }
    if (StateID !== "") {
      StaID = StateID;
    }
    if (CountryID !== "") {
      Coun = CountryID;
    }
    if (AccName !== "") {
      AcName = AccName;
    }
    bodyFormData.append("UserID", sessionStorage.UID);
    bodyFormData.append("AccountName", AccoName);
    bodyFormData.append("ActivityTypeID", ActivityTypeID);
    bodyFormData.append("IndustryID", IndustryID);
    bodyFormData.append("CountryID", CountryID);
    bodyFormData.append("City", City);
    bodyFormData.append("StateID", StateID);
    bodyFormData.append("SearchString", AccName);
    fetchData("MessageCenter/List", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
      setAccountOptions(responseAccount['cmbAccount']);
    }
  }, [responseAccount['cmbAccount']]);

  // useEffect(() => {
  //   if (responseState !== undefined) {
  //    // debugger;
  //     if (responseState["cmbStates"] !== undefined) {
  //       setStatecmb(responseState["cmbStates"]);
  //     }
  //   }
  // }, [responseState]);

  useEffect(() => {

    if (responseState['cmbState'] !== undefined && responseState['cmbState'].length > 0) {
      // debugger;
      setStateOptions(responseState['cmbState']);
    }
  }, [responseState['cmbState']]);

  useEffect(() => {
    if (responseCountry !== undefined) {
      debugger;
      if (responseCountry["cmbCountry"] !== undefined) {
        setCountrycmb(responseCountry["cmbCountry"]);
      }
    }
  }, [responseCountry]);

  useEffect(() => {
    if (responseType !== undefined) {
      // debugger;
      if (responseType["cmbActivityType"] !== undefined) {
        setActivitycmb(responseType["cmbActivityType"]);
      }
    }
  }, [responseType]);

  useEffect(() => {
    if (responseIndustry !== undefined) {
      // debugger;
      if (responseIndustry["cmbIndustry"] !== undefined) {
        setIndustrycmb(responseIndustry["cmbIndustry"]);
      }
    }
  }, [responseIndustry]);


  useEffect(() => {
    const gridCols = [
      // {
      //   field: "id",
      //   headerName: ".",
      //   renderCell: (params) =>
      //     (<strong> <Link to={{ pathname: "/account/AccountView", state: { AccountID: params.id, AccountName: params.row.AccountName } }} style={{ color: 'blue' }} >Select</Link> </strong>)
      //   ,
      //   //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 70,
      // },
      {
        field: "ContactName",
        headerName: "Contact Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "AccountCode",
        headerName: "Account Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "AccountName",
        headerName: "Account Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 220,
        renderCell: (params) => (
          <Tooltip title={params.row.AccountName} >
            <span className="table-cell-trucate">{params.row.AccountName}</span>
          </Tooltip>
        )
      },
      {
        field: "Mobile",
        headerName: "Mobile",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
        renderCell: (params) => {
          return (
            <a href="javascript:;" onClick={() => { WhatsAppMessage(params.row.Mobile); }} >{params.row.Mobile}</a>
          );
        }
      },
      {
        field: "Email",
        headerName: "Email",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 250,
        renderCell: (params) => (
          <Tooltip title={params.row.Email} >
            <span className="table-cell-trucate">{params.row.Email}</span>
          </Tooltip>
        ),
      },

    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]);

  useEffect(() => {
    PopulateData();
    TypeData();
    StateData();
    AccountData();
    CountryData();
    IndustryData();
  }, [])

  const onStateChange = (event, newValue) => {
    // debugger;
    setStateName(newValue);
    setStateID(newValue.id)
  }

  const onACCChange = (event, newValue) => {
    // debugger;
    setAccountName(newValue);
    setAccountID(newValue.id);
  }



  return (
    <div>
      <Grid container direction="row" style={{ marginTop: -10 }} >
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 28, paddingTop: 0, paddingBottom: 0 }}>
          <BiztranControls.Autocomplete
            label="Account Name"
            width="175px"
            options={AccountOptions}
            onChange={onACCChange}
            value={AccName}>
          </BiztranControls.Autocomplete>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
          <BiztranControls.Select
            label="Activity Type"
            id="Type"
            width="180px"
            options={Activitycmb}
            onChange={(e) => setActivityTypeID(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
          <BiztranControls.Select
            label="Industry"
            id="industry"
            width="180px"
            options={Industrycmb}
            onChange={(e) => setIndustryID(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" style={{ marginTop: 0 }}>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 28 }} >
          <BiztranControls.Autocomplete
            label="State Name"
            width="180px"
            options={StateOptions}
            onChange={onStateChange}
            value={State}>
          </BiztranControls.Autocomplete>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }} >
          <BiztranControls.Input
            label="City"
            id="city"
            style={{ width: "180px" }}
            onChange={(e) => setCity(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }} >
          <BiztranControls.Select
            label="Country"
            id="Country"
            width="180px"
            options={Countrycmb}
            onChange={(e) => setCountryID(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} container direction="row" style={{ marginTop: 23 }} >
          <TextareaAutosize
            aria-label="Minimum height"
            minRows={4}
            placeholder="WhatsApp Message"
            id="message"
            onChange={(e) => { setMessage(e.target.value) }}
            style={{ width: 660 }}
          />
          {/* <TextField
            id="outlined-multiline-static"
            label="Multiline"
            multiline
            rows={4}
            onChange={(e) => setMessage(e.target.value)}
          /> */}
          <BiztranControls.Button
            text="SEARCH"
            startIcon={<SearchIcon />}
            onClick={() => {
              PopulateData();
            }}
          />
          <label style={{ fontWeight: 'bold', width: 25, marginTop: 13 }}>{Count}</label>
          <BiztranControls.Button
            text="Send Email"
            style={{ width: "120px" }}
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => {
              handleOpenModal();
            }}
          />
        </Grid>
        <Grid item xs={12} >
          <BiztranControls.DataGrid
            rowHeight={25}
            headerHeight={34}
            rows={rows}
            columns={columns}
            checkboxSelection
            /* onRowSelected={(GridRowSelectedParams) => {
              console.log(GridRowSelectedParams);
              //SelectedData.push(GridRowSelectedParams.data);
              //setSelectedRows(SelectedData);
            }} */
            pageSize={15}
            rowsPerPageOptions={[15]}
            onSelectionModelChange={(ids) => {
              debugger;
              const selectedIDs = new Set(ids);
              const selectedRows = rows.filter((row) =>
                selectedIDs.has(row.id),
              );
              setSelectedRows(selectedRows);
            }}
            //hideFooterPagination={true}
            //hideFooter={true}
            Height="470px"
            // autoHeight={true}
            Width="100%"
          />
        </Grid>
      </Grid>
      <ModalFrame
        title="Send Email"
        maxWidth="md"
        isOpen={isOpen}
        headerAlign="center"
        setOpen={setOpen}
      >
        <SendEmail
          AccountID={AccountID}
          setOpen={setOpen}
          EmailData={EmailData}
          EmailCount={EmailCount}
        //getByIDData={PopulateData}
        />
      </ModalFrame>
    </div>
  );
};

export default MessageCenter;